import * as React from 'react';
import { graphql, withApollo } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import { RadioGroup } from 'components/common/RadioGroup/RadioGroup';
import { updateTemplateValuesListFieldValue, templateDdeActionsTriggered } from 'graphql/operations';
import { decodeHtml, encodeHtml } from 'utils/htmlEncoderDecoder';
import { OTHER_TEXT_MAX_CHARACTERS } from 'utils/constants';
import SaveTemplateAnswerHOC from '../SaveTemplateAnswerHOC';
import TemplateFieldUpdatesHOC from '../TemplateFieldUpdatesHOC';

export const TemplateRadioGroupAnswer = props => {
  const { question, disabled, save, filterValues } = props;

  // Local Vars
  const { possibleValues, calculated, listValue } = question;
  let options = possibleValues.map(possibleValue => {
    const { valuesListId, value: possibleValueValue, enableOtherText } = possibleValue;
    return { value: valuesListId, label: decodeHtml(possibleValueValue), enableOtherText };
  });
  if (filterValues && filterValues.length > 0) {
    options = options.filter(option => filterValues.indexOf(option.value) > -1);
  }

  // Event Handlers
  const handleValueChange = React.useCallback(
    (selectedValue, otherText) => {
      save([selectedValue], encodeHtml(otherText) || null);
    },
    [save]
  );
  const handleValidationError = React.useCallback(
    (selectedValue, otherText) => {
      save([selectedValue], encodeHtml(otherText) || null);
    },
    [save]
  );

  // Render
  const selected = listValue ? listValue[0] : null;
  return (
    <RadioGroup
      options={options}
      disabled={calculated || disabled}
      selected={selected}
      onChange={handleValueChange}
      onValidationError={handleValidationError}
      otherText={decodeHtml(question.otherText)}
      otherTextMaxCharacters={OTHER_TEXT_MAX_CHARACTERS}
    />
  );
};

export const TemplateRadioGroupAnswerHOC = compose(
  withApollo,
  graphql(updateTemplateValuesListFieldValue, { name: 'fieldMutation' }),
  graphql(templateDdeActionsTriggered, { name: 'templateDdeActionsTriggered' }),
  TemplateFieldUpdatesHOC,
  SaveTemplateAnswerHOC,
  mapProps(props => ({
    question: props.question,
    disabled: props.disabled,
    invokeActionsForFields: props.invokeActionsForFields,
    filterValues: props.filterValues,
    save: props.save
  }))
);

export default TemplateRadioGroupAnswerHOC(TemplateRadioGroupAnswer);
